export default __webpack_public_path__ + "media/images/checkmark-aa904cfae314057169beadcebe20f020.svg";